import React from 'react';
import {
  USYS_DATA_ATTRS,
  USYS_FORM_TYPES,
} from '@packages/systems/users/constants';
import {pluginName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Atom} from '@packages/systems/wfdl';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const UserAccountForm = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild, context}) => {
    return (
      <form
        {...generateAttributes(attributes, classes)}
        method="post"
        {...{[USYS_DATA_ATTRS.formType]: USYS_FORM_TYPES.account}}
      >
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child, context)
        )}
      </form>
    );
  }
);

const config = Atom.create({
  constraints: {
    ancestors: [{is: 'UserAccountFormWrapper', rule: 'ExactlyOne'}],
    page: [{type: 'UtilityPage', is: 'usys-user-account'}],
    descendants: [
      {
        is: 'UserFormEmailInput',
        rule: 'ExactlyOne',
      },
      {
        is: 'UserAccountFormSaveButton',
        rule: 'ExactlyOne',
      },
      {
        is: 'UserAccountFormCancelButton',
        rule: 'ExactlyOne',
      },
      {
        is: 'UserFormPasswordInput',
        rule: 'Forbid',
      },
    ],
    pinToParent: true,
  },
  displayName: 'User Account Form',
  render: UserAccountForm,
  showEmpty: true,
  dataType: createIntegratedRootAliasInstance(
    qualify(pluginName('Users'), typeName('UserForm'))
  ),
});

export default config;
